import React from 'react'
import OdxIcon from '../Odx-Icon'
import {odxIconSets} from '../../constants'

interface OdxCheckboxProps {
    label: string
    checked: boolean
    disabled?: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    className?: string
    description?: string
    id?: string
}

/** Usage
 * <OdxCheckbox
 * name={"Test"}
 * value={"Test"}
 * label={"Checkbox"}
 * disabled={false}
 * checked={isMigrate}
 * onChange={() =>setIsMigrate(!isMigrate) } />
 */

/**
 * Checkbox component. Is used to display a checkbox.
 * @param label is the label to display next to the checkbox
 * @param checked is the state of the checkbox
 * @param onChange is the function to call when the checkbox state changes
 * @param className is the additional classes to apply to the div around the checkbox
 * @param description is the description to display below the checkbox
 * @param disabled is the state of the checkbox
 */

const OdxCheckbox: React.FC<OdxCheckboxProps> = ({label, checked, onChange, className, description, disabled, id}) => {
    return (
        <div
            className={`odx-checkbox ${checked ? 'is-active' : ' '} ${className ? className : ''} ${disabled ? 'is-disabled' : ' '}`}>
            <label className='odx-checkbox__label'>
                <input
                    type='checkbox'
                    id={"OdxCheckboxInput_" + id}
                    className='odx-checkbox__input'
                    checked={checked}
                    onChange={onChange}
                    aria-checked={checked}
                    disabled={disabled}
                />

                <div className='odx-checkbox__indicator'>
                    <OdxIcon name={'check'} size={'md'} iconSet={odxIconSets.core}/>
                </div>
                <div className='odx-checkbox__content'>
                    {label}
                    {description && <span className='odx-checkbox__subtitle'>{description}</span>}
                </div>
            </label>
        </div>
    )
}

export default OdxCheckbox
